import { Injectable } from '@angular/core';

@Injectable()
export class InstanaService {
  constructor() {
    window['ineum'] = window['ineum'] || this.fakeFunction;
  }

  setUserData(uid: string) {
    return window['ineum']('user', uid, null, null);
  }

  setCurrentStep(pageName: string) {
    return window['ineum']('page', pageName);
  }

  setMetaTag(key: string, value: string) {
    return window['ineum']('meta', key, value);
  }

  setIgnoreUrls() {
    return window['ineum']('ignoreUrls', [/localhost/i, /hmg-trade/i]);
  }

  private fakeFunction(key: string, param1?: any, param2?: any, param3?: any) {
    return true;
  }
}
